import { Hidden } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({

    playlistContainer: {
        float: "left",
        width: "10%",
        overflow: "auto",
        borderLeft: "5px solid black",
        height: "100%"

    },

    stepLine: {


        top: "5%",
        position: "relative",
        bottom: "5%",
        height: "90%"


    },


    playlistHeader: {
        background: "#3f51b5",
        color: "white",
        height: "10%",

    },

    playlistLabel: {
        wordBreak: "break-all"
    },

    playlistTimeline: {
        height: "85%",
        width: "80%",

        position: "absolute"
    },

    playlistContent: {
        height: "100%",
        overflow: "auto",
        position: "relative"
    }
}));

export { useStyles };